<template>
  <div class="login">
    <div class="top">
      <img class="logo" src="../../static/img/logo.png" />
      <h5 class="top_tit"><span>|</span> 会员管理系统</h5>
      <div class="top_btns">
        <a
          class="toNews"
          href="https://www.caq.org.cn/html/xhxw/zxxw/list.html"
          target="_blank"
          >协会新闻</a
        >
        <a
          class="toNotice"
          href="https://www.caq.org.cn/html/tzgg/list.html"
          target="_blank"
          >通知公告</a
        >
        <router-link class="search" to="/search"> 会员查询 </router-link>
      </div>
    </div>
    <div class="center">
      <div class="con">
        <div class="information">
          <span class="note" v-show="show">点击访问单位会员官网</span>
          <el-tabs
            style="padding: 0 20px"
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="会员动态"
              name="first"
              class="news"
              style="font-size: 15px"
            >
              <ul class="news_list">
                <li v-for="item in dt">
                  <a :href="item.href" target="_blank">
                    <p
                      class="news_right_pro line1"
                      :title="item.title"
                      style="color: #909090"
                    >
                      {{ item.title }}
                    </p>
                    <span style="color: #909090">{{ item.time }}</span>
                  </a>
                </li>
                <span class="more" @click="getdtMore">查看更多会员动态</span>
              </ul>
            </el-tab-pane>
            <el-tab-pane
              label="会员风采"
              name="second"
              class="demeanour"
              style="font-size: 15px"
            >
              <ul class="demeanour_list">
                <li v-for="(item, index) in fc" :key="index">
                  <a
                    target="_blank"
                    :href="
                      item.website == ''
                        ? 'javascript:;'
                        : item.website.substr(0, 7).toLowerCase() == 'http://'
                        ? item.website
                        : item.website.substr(0, 8).toLowerCase() == 'https://'
                        ? item.website
                        : 'https://' + item.website
                    "
                  >
                    <div>
                      <p class="demeanour_tit line1" :title="item.name">
                        {{ item.name }}
                      </p>
                      <span>{{ item.publish_time.split(" ")[0] }}</span>
                    </div>
                    <p
                      style="color: #909090"
                      class="demeanour_pro ellipsis"
                      :title="item.mien"
                    >
                      {{ item.mien }}
                    </p>
                  </a>
                </li>
                <span class="more" @click="getfcMore">查看更多会员风采</span>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-form
          :model="ruleForm2"
          :rules="rules2"
          ref="ruleForm2"
          label-position="left"
          label-width="0px"
          class="demo-ruleForm login-container"
        >
          <h3 class="title">会员登录</h3>
          <!--用户名-->
          <el-form-item prop="account">
            <el-input
              prefix-icon="iconfont el-icon-user"
              type="text"
              v-model="ruleForm2.account"
              auto-complete="off"
              placeholder="请输入会员编号/用户名"
              clearable
            ></el-input>
          </el-form-item>
          <!--密码-->
          <el-form-item prop="checkPass">
            <el-input
              prefix-icon="iconfont el-icon-lock"
              type="password"
              v-model="ruleForm2.checkPass"
              auto-complete="off"
              placeholder="请输入密码(区分大小写)"
              show-password
            ></el-input>
          </el-form-item>

          <!--验证码-->
          <div class="drag" ref="dragDiv">
            <div class="drag_bg"></div>
            <div class="drag_text">{{ confirmWords }}</div>
            <div
              ref="moveDiv"
              @mousedown="mousedownFn($event)"
              :class="{ handler_ok_bg: confirmSuccess }"
              class="handler handler_bg"
              style="position: absolute; top: 0px; left: 0px"
            ></div>
          </div>
          <!--提交-->
          <el-form-item style="width: 100%">
            <el-button
              class="btn"
              type="primary"
              style="width: 45%"
              @click.native.prevent="handleSubmit"
              :loading="logining"
              >登录</el-button
            >
            <router-link class="join" to="/register">注册</router-link>
          </el-form-item>
          <div class="form_bot">
            <a class="remember"
              ><input
                class="checkbox"
                id="checkbox"
                v-model="checked"
                type="checkbox"
              />
              <label for="checkbox">记住登录状态</label></a
            >
            <router-link class="forget" to="/returnPassword1">
              忘记密码？
            </router-link>
            <a
              class="service"
              target="_blank"
              href="https://frontend.caq.org.cn/manual.pdf"
              >使用说明书</a
            >
          </div>
          <div class="tj">
            <a>推荐浏览器：</a>
            <a href="https://www.google.cn/chrome/" target="_blank"
              >谷歌浏览器</a
            >
            <a href="https://ie.sogou.com/" target="_blank">搜狗浏览器</a>
            <a href="https://browser.360.cn/se/" target="_blank">360浏览器</a>
          </div>
        </el-form>
        <img class="enter" @click="toActivity" :src="this.img" />
      </div>
    </div>
    <div class="bottom">
      <div class="bottom_con">
        <div class="bottom_con_l">
          <img class="kf_img" src="../../static/img/icon18.png" />
          <div>
            <p style="color: #005eb5; font-size: 14px; font-weight: bold">
              协会客服
            </p>
            <p>010-68416055</p>
            <p>接通请转接会员部 周一至周五 09:00-17:00</p>
          </div>
        </div>
        <div class="bottom_con_r">
          <p>中国质量协会 版权所有 未经授权请勿转载任何图文或建立镜像</p>
          <p>制作单位：中国质量协会网络中心</p>
          <p>
            Copyright&#169;2003-2008 All rights reserved 京ICP备05018279号-1
            京公网安备 110102000185
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'
import { setCookie, getCookie } from '../untils/cookie'
import "../../static/css/table.css"
import bottom from './Bottom'
export default {
  components: {
    bottom
  },
  data () {
    return {
      show: false,
      fc: [],
      dt: [],
      flag: true,
      flags: true,
      img: '',
      add: 1,
      num: 0,
      activeName: 'first',
      beginClientX: 0,
      /*距离屏幕左端距离*/
      mouseMoveStata: false,
      /*触发拖动状态  判断*/
      maxwidth: '',
      /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords: '拖动滑块验证',
      /*滑块文字*/
      confirmSuccess: false,
      /*验证成功判断*/
      logining: false,
      checked: false,
      ruleForm2: {
        account: '',
        checkPass: '',
      },
      rules2: {
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        },],
        checkPass: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        },],
      }
    };
  },
  created () { },
  mounted () {
    this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
    document.getElementsByTagName('html')[0].addEventListener('mousemove', this.mouseMoveFn);
    document.getElementsByTagName('html')[0].addEventListener('mouseup', this.moseUpFn);
    if (localStorage.getItem('sessionid')) {
      var sessionid = localStorage.getItem('sessionid');
    }
    var data = {
      sessionid: sessionid,
    }
    this.$axios({
      method: 'post',
      url: 'user/nolanding',
      data: Qs.stringify(data)
    }).then(response => {
      if (response.data.state == 1) {
        sessionStorage.setItem('bh', response.data.token.serial_number);
        sessionStorage.setItem('name', response.data.token.user_name);
        sessionStorage.setItem('Token', response.data.token.token);
        sessionStorage.setItem('step', response.data.token.step_status);
        sessionStorage.setItem('type', response.data.token.type);
        sessionStorage.setItem('zhiwei', response.data.token.director_status);
        sessionStorage.setItem('ziliao', response.data.token.task_status);
        sessionStorage.setItem('reset', response.data.token.reset);
        //2:企业用户;3:个人用户;4:常务理事;5:副会长;
        switch (Number(response.data.token.type)) {
          //			            		2:企业用户
          case 2:
            switch (Number(response.data.token.step_status)) {
              case 0:
                this.$router.push('/step1');
                break;
              case 1:
                this.$router.push('/step2');
                break;
              case 2:
                this.$router.push('/step3');
                break;
              default:
                this.$router.push('/index');
            }
            break;
          //3:个人用户
          case 3:
            switch (Number(response.data.token.step_status)) {
              case 0:
                this.$router.push('/person1');
                break;
              case 1:
                this.$router.push('/person2');
                break;
              default:
                this.$router.push('/index');
            }
            break;
          case 4:
            //						        4:常务理事;
            this.$router.push('/index');
            break;
          case 5:
            //						        5:副会长
            this.$router.push('/index');
            break;
          default:
        }
      } else {
        //					this.$toast(response.data.msg);
      }
    });

    //获取活动图片
    this.$axios({
      method: 'post',
      url: '/user/getimg',
    }).then(response => {
      if (response.data.state == 1) {
        this.img = response.data.data.image_url;
      }
    });
    var data1 = {
      page: this.add
    };
    //动态
    this.$axios({
      method: 'post',
      url: 'user/memberdynamic',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 1) {
        if (response.data.data.length != 0) {
          this.dt = response.data.data
        }
      }
    });
    var data2 = {
      num: this.num
    };
    //风采
    this.$axios({
      method: 'post',
      url: 'user/demeanor',
      data: Qs.stringify(data2)
    }).then(response => {
      if (response.data.state == 1) {
        if (response.data.data.length != 0) {
          this.fc = response.data.data
        }
      }
    });

  },
  methods: {
    //跳转
    toActivity () {
      this.$router.push('/activity');
    },
    //获取动态更多数据
    getdtMore () {
      if (this.flag) {
        this.flag = false;
        this.add++;
        var data = {
          page: this.add
        };
        this.$axios({
          method: 'post',
          url: 'user/memberdynamic',
          data: Qs.stringify(data)
        }).then(response => {
          this.flag = true;
          if (response.data.state == 1) {
            if (response.data.data.length != 0) {
              for (var i in response.data.data) {
                this.dt.push(response.data.data[i]);
              }
            }
          } else if (response.data.state == 2) {
            this.$toast(response.data.msg);
          }
        });
      }
    },
    //获取更多风采数据
    getfcMore () {
      if (this.flags) {
        this.flags = false;
        this.num += 4;
        var data = {
          num: this.num
        };
        this.$axios({
          method: 'post',
          url: 'user/demeanor',
          data: Qs.stringify(data)
        }).then(response => {
          this.flags = true;
          if (response.data.state == 1) {
            if (response.data.data.length != 0) {
              for (var i in response.data.data) {
                this.fc.push(response.data.data[i]);
              }
            }
          } else if (response.data.state == 2) {
            this.$toast(response.data.msg);
          }
        });
      }
    },
    handleClick (tab, event) {
      if (tab.name == "second") {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    mousedownFn: function (e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true;
        this.beginClientX = e.clientX;
      }
    }, //mousedoen 事件
    successFunction () {
      this.confirmSuccess = true
      this.confirmWords = '验证通过';
      if (window.addEventListener) {
        document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn);
        document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn);
      } else {
        document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => { });
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
    }, //验证成功函数
    mouseMoveFn (e) {
      if (this.mouseMoveStata) {
        let width = e.clientX - this.beginClientX;
        if (width > 0 && width <= this.maxwidth) {
          document.getElementsByClassName('handler')[0].style.left = width + 'px';
          document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
        } else if (width > this.maxwidth) {
          this.successFunction();
        }
      }
    }, //mousemove事件
    moseUpFn (e) {
      this.mouseMoveStata = false;
      var width = e.clientX - this.beginClientX;
      if (width < this.maxwidth) {
        document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
      }
    },

    handleSubmit (ev) {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          if (!this.confirmSuccess) {
            this.$toast('请通过验证');
            return false;
          };
          if (this.checked) {
            var rememberMe = 1;
          } else {
            var rememberMe = null;
          }
          let data = {
            'username': this.ruleForm2.account,
            'password': this.ruleForm2.checkPass,
            'rememberMe': rememberMe
          };
          this.$axios({
            method: 'post',
            url: 'user/login',
            data: Qs.stringify(data)
          }).then(response => {
            if (response.data.state == 1) {
              localStorage.setItem('sessionid', response.data.sessionid);
              sessionStorage.setItem('bh', response.data.token.serial_number);
              sessionStorage.setItem('name', response.data.token.user_name);
              sessionStorage.setItem('Token', response.data.token.token);
              sessionStorage.setItem('step', response.data.token.step_status);
              sessionStorage.setItem('type', response.data.token.type);
              sessionStorage.setItem('zhiwei', response.data.token.director_status);
              sessionStorage.setItem('ziliao', response.data.token.task_status);
              sessionStorage.setItem('reset', response.data.token.reset);
              //2:企业用户;3:个人用户;4:常务理事;5:副会长;
              switch (Number(response.data.token.type)) {
                //			            		2:企业用户
                case 2:
                  switch (Number(response.data.token.step_status)) {
                    case 0:
                      this.$router.push('/step1');
                      break;
                    case 1:
                      this.$router.push('/step2');
                      break;
                    case 2:
                      this.$router.push('/step3');
                      break;
                    default:
                      this.$router.push('/index');
                  }
                  break;
                //3:个人用户
                case 3:
                  switch (Number(response.data.token.step_status)) {
                    case 0:
                      this.$router.push('/person1');
                      break;
                    case 1:
                      this.$router.push('/person2');
                      break;
                    default:
                      this.$router.push('/index');
                  }
                  break;
                case 4:
                  //						        4:常务理事;
                  this.$router.push('/index');
                  break;
                case 5:
                  //						        5:副会长
                  this.$router.push('/index');
                  break;
                default:
              }
            } else {
              this.$toast(response.data.msg);
            }
          });
        }
      });
    },
  }
}
</script>
<style scoped>
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ellipsis {
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.login {
  width: 100%;
  height: auto;
  background: #fff;
  font-family: PingFangSC-Medium;
  font-size: 20px;
}

.top {
  width: 1080px;
  margin: 0 auto;
  height: 80px;
  position: relative;
}

.logo {
  width: 211px;
  height: 43px;
  position: absolute;
  top: 16px;
  left: 0;
}

.top_tit {
  position: absolute;
  top: 26px;
  left: 230px;
  height: 28px;
  font-weight: bold;
  color: rgba(0, 94, 179, 1);
  line-height: 28px;
}

.top_tit span {
  height: 17px;
  color: #e8e8e8;
}
.top_btns {
  padding: 0 15px;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: 0;
  width: 400px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_btns a {
  font-size: 14px;
  font-weight: 600;
  color: #005fb0;
}
.search {
  padding-left: 20px;
  background: url(../../static/img/icon13.png) no-repeat left center;
  background-size: 14px 14px;
}
.toNews {
  right: 200px;
  padding-left: 20px;
  background: url(../../static/img/icon12.png) no-repeat left center;
  background-size: 14px 14px;
}
.toNotice {
  right: 300px;
  padding-left: 20px;
  background: url(../../static/img/icon11.png) no-repeat left center;
  background-size: 14px 14px;
}
.center {
  width: 100%;
  height: auto;
  padding-bottom: 100px;
  background: #1e3eb8 url(../../static/img/bg1.png) no-repeat;
  background-size: 100%;
}
.con {
  position: relative;
  width: 1080px;
  padding-top: 93px;
  margin: 0 auto;
  height: auto;
  overflow: hidden;
}
/*会员信息展示*/
.information {
  position: relative;
  float: left;
  width: 560px;
  padding-bottom: 25px;
  background: #fff;
  text-align: left;
  font-size: 20px;
}
.note {
  position: absolute;
  right: 20px;
  top: 0;
  font-size: 14px;
  color: red;
  line-height: 40px;
}
.el-tabs__item {
  font-size: 16px !important;
}
.information ul {
  text-align: center;
  height: 530px;
  overflow-y: scroll;
}
/*.information ul::-webkit-scrollbar {
        display: none;
    }*/
.information ul li {
  text-align: left;
}
.more {
  cursor: pointer;
  color: rgba(31, 77, 199, 1);
  font-size: 14px;
  font-weight: bold;
}
/*动态*/
.news {
  width: 100%;
}
.news li {
  border-bottom: 1px solid #ccc;
}
.news_list li:last-of-type {
  margin-bottom: 20px;
}
.news a {
  display: block;
  width: 100%;
  height: 43px;
  line-height: 43px;
  color: #404040;
}
.news_right_pro {
  float: left;
  width: 75%;
  font-size: 14px;
}
.news a span {
  font-size: 14px;
  float: right;
}

/*风采*/
.demeanour {
  width: 100%;
}
.demeanour li {
  border: 1px solid #ccc;
  background: #fff;
  height: 112px;
  margin-bottom: 15px;
  box-sizing: border-box;
}
.demeanour li:hover {
  border: 1px solid #4b97f0;
}
.demeanour a {
  display: block;
  height: 100%;
}
.demeanour_list div {
  margin-bottom: 8px;
  height: 35px;
  line-height: 35px;
  background: #4b97f0;
}
.demeanour_tit {
  width: 75%;
  float: left;
  padding-left: 44px;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  background: url(../../static/img/company.png) no-repeat top 7px left 13px;
  background-size: 17px 21px;
}
.demeanour_list div span {
  float: right;
  font-size: 14px;
  color: #fff;
  padding-right: 25px;
}
.demeanour_pro {
  font-size: 14px;
  margin-bottom: 7px;
  padding: 0 13px;
}
.demeanour_time {
  padding: 0 13px;
  font-size: 12px;
}

/*登录*/
.login-container {
  position: relative;
  float: right;
  width: 400px;
  background: #fff;
  padding: 17px 20px 35px;
  box-sizing: border-box;
}
.title {
  margin-bottom: 22px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #095ca7;
  font-family: PingFangHK-Medium, PingFangHK;
}
.drag {
  position: relative;
  background-color: #e8e8e8;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 25px;
}

.handler {
  width: 40px;
  height: 38px;
  border: 1px solid #ccc;
  cursor: move;
}

.handler_bg {
  background: #fff url(../../static/img/handle.png) no-repeat center;
}

.handler_ok_bg {
  background: #fff url(../../static/img/icon5.png) no-repeat center;
}

.drag_bg {
  background-color: #7ac23c;
  height: 40px;
  width: 0px;
}

.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}

.btn {
  float: left;
  font-size: 18px;
  background: #fff;
  background: rgba(0, 95, 179, 1);
  font-family: PingFangSC-Medium, PingFang SC;
}
.btn:hover {
  background: rgba(0, 95, 179, 0.6);
}
.join {
  float: right;
  font-size: 17px;
  width: 45%;
  height: 44px;
  line-height: 44px;
  border-radius: 5px;
  background: rgba(255, 150, 0, 1);
  color: #fff;
}
.join:hover {
  background: rgba(255, 150, 0, 0.6);
}
.form_bot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 17px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  line-height: 17px;
}
.form_bot a {
  display: flex;
  align-items: center;
  color: #404040;
}
label {
  cursor: pointer;
}
.checkbox {
  margin-right: 8px;
  vertical-align: middle;
  display: inline-block;
  width: 14px;
  height: 14px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(208, 208, 208, 1);
}
.form_bot .forget {
  padding-left: 20px;
  background: url(../../static/img/icon13.png) no-repeat left center;
  background-size: 14px 14px;
  color: #005fb3;
}
.form_bot .service {
  padding-left: 20px;
  background: url(../../static/img/icon14.png) no-repeat left center;
  background-size: 14px 14px;
  color: #005fb3;
}
.tj {
  width: 100%;
  height: 44px;
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 12px;
  position: absolute;
  left: 0;
  bottom: -44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
}
.tj a {
  color: #404040;
  margin-right: 7px;
}
.tj a:nth-of-type(2) {
  cursor: pointer;
  padding-left: 20px;
  background: url(../../static/img/icon15.png) no-repeat left center;
  background-size: 14px 14px;
}
.tj a:nth-of-type(3) {
  cursor: pointer;
  padding-left: 20px;
  background: url(../../static/img/icon16.png) no-repeat left center;
  background-size: 14px 14px;
}
.tj a:nth-of-type(4) {
  cursor: pointer;
  padding-left: 20px;
  background: url(../../static/img/icon17.png) no-repeat left center;
  background-size: 14px 14px;
}
.enter {
  position: absolute;
  width: 400px;
  height: 160px;
  bottom: 0;
  right: 0;
}
.bottom {
  height: 100px;
  padding-top: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
}
.bottom_con {
  width: 1080px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.bottom_con p {
  text-align: right;
  line-height: 25px;
}
.bottom_con_l {
  display: flex;
  justify-content: center;
}
.bottom_con_l p {
  text-align: left;
}
.kf_img {
  width: 32px;
  height: 32px;
  margin-right: 27px;
  margin-top: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue